import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Lock, Cpu, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { admin, ready, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (ready && admin) nav("/admin/dashboard"); }, [ready, admin, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav("/admin/dashboard"); }
    catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <div className="w-10 h-10 rounded-lg bg-[#2563EB] flex items-center justify-center"><Cpu className="w-5 h-5 text-white" /></div>
          <div><span className="font-display font-extrabold text-white text-lg">REVONA</span><span className="block text-[10px] font-mono tracking-[0.25em] text-cyan-400">ADMIN PORTAL</span></div>
        </div>
        <form onSubmit={submit} className="tactical-card p-8" data-testid="admin-login-form">
          <div className="flex items-center gap-2 mb-6"><Lock className="w-5 h-5 text-cyan-400" /><h1 className="font-display text-xl font-bold text-white">Administrator Sign In</h1></div>
          {err && <div className="bg-rose-500/10 border border-rose-500/30 text-rose-400 text-sm rounded-lg px-4 py-2.5 mb-4" data-testid="admin-login-error">{err}</div>}
          <label className="block text-xs font-medium text-slate-400 mb-1.5">Email</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" data-testid="admin-email-input"
            className="w-full bg-[#0A0E1A] border border-[#1E2F4D] rounded-lg px-3.5 py-2.5 text-sm text-white mb-4 focus:outline-none focus:border-[#2563EB]" />
          <label className="block text-xs font-medium text-slate-400 mb-1.5">Password</label>
          <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" data-testid="admin-password-input"
            className="w-full bg-[#0A0E1A] border border-[#1E2F4D] rounded-lg px-3.5 py-2.5 text-sm text-white mb-6 focus:outline-none focus:border-[#2563EB]" />
          <button type="submit" disabled={loading} data-testid="admin-login-btn"
            className="w-full inline-flex items-center justify-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] btn-glow disabled:opacity-60 text-white font-semibold px-6 py-3 rounded-full">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Lock className="w-4 h-4" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
